/**
 * Whether the side menu's "Show Offline" / "Show Recent" button is disabled (app#369).
 *
 * With `hideOffline` on (the default), the nodes query drops every node that has been offline for
 * more than OFFLINE_NODE_VISIBILITY_HOURS. So an EMPTY list does not mean the org has no nodes: in
 * an org where every node has been offline that long, the list is empty and the nodes are only
 * hidden. The button used to be disabled on `!nodes.length`, and then it could never be turned on,
 * so those nodes could not be reached or removed from the app.
 *
 * ⚠ The button is disabled only when the loaded list is COMPLETE and empty: the org has no node
 * at all, and there is nothing to show in either state. Completeness comes from the STORE
 * (`useNode.nodesComplete`), not from `hideOffline`, because `hideOffline` flips before the new
 * node set arrives, and a failed read keeps the old set. While the list is incomplete, the button
 * stays enabled, so a failed read can be tried again.
 */
export function isOfflineFilterDisabled(params: { nodeCount: number; nodesComplete: boolean }): boolean {
  return params.nodeCount === 0 && params.nodesComplete
}
